import { Person } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React, { useState } from 'react';
import { calculateAvatarAbbreviation } from "./calculateAvatarAbbreviation.js";
import styles from "./Avatar.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const AvatarVariant = ['OCKER', 'GREEN', 'BLUE', 'BERRY', 'RED', 'GRAY'];
export function Avatar({
  name,
  image,
  variant = 'GRAY',
  size = 'M',
  className
}) {
  const [imageError, setImageError] = useState(false);
  const imageToUse = imageError ? undefined : image;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.avatar, styles[size], {
      [styles.withImage]: !!imageToUse
    }, styles[name ? variant : 'GRAY'], className),
    children: imageToUse ? /*#__PURE__*/_jsx("img", {
      src: imageToUse,
      className: styles.image,
      alt: name,
      onError: setImageError.bind(undefined, true)
    }) : name ? /*#__PURE__*/_jsx("abbr", {
      children: calculateAvatarAbbreviation(name)
    }) : /*#__PURE__*/_jsx(Person, {
      className: styles.defaultAvatar
    })
  });
}